<template>
  <div class="box">
    <div class="box-header">
      <h2>{{ $t('ACCOUNT.NEWSLETTER.HEADING') }}</h2>
    </div>
    <div class="box-content">
      <div class="newsletters form-group sprd-newsletter">
        <div class="newsletter">
          <ToggleSwitch
            class="newsletter-switch"
            :model-value="data.partner"
            condensed
            @update:model-value="setPartnerNewsletter"
          >
            <strong>{{ $t('ACCOUNT.CONTACT.NEWSLETTER.PARTNER') }}</strong>
          </ToggleSwitch>
          <p>{{ $t('ACCOUNT.CONTACT.NEWSLETTER.PARTNER_TOOLTIP') }}</p>
        </div>
        <div class="newsletter">
          <ToggleSwitch
            v-model="data.customer"
            class="newsletter-switch"
            condensed
            @update:model-value="setCustomerNewsletter"
          >
            <strong>{{ $t('ACCOUNT.CONTACT.NEWSLETTER.CUSTOMER') }}</strong>
          </ToggleSwitch>
          <p>{{ $t('ACCOUNT.CONTACT.NEWSLETTER.CUSTOMER_TOOLTIP') }}</p>
        </div>
      </div>
      <AccountPageActions
        :save="saveNewsletterData"
        :disabled="!hasChanged"
        @on-revert="reset"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import ToggleSwitch from 'commons/toggleSwitch/ToggleSwitch.vue';
import AccountPageActions from 'src/app/partnerarea/account/AccountPageActions.vue';
import { useUserNewsletterStore } from 'commons/stores/user/userNewsletter';

export default {
  name: 'Newsletter',
  components: {
    AccountPageActions,
    ToggleSwitch,
  },
  data() {
    return {
      initialized: false,
    };
  },
  computed: {
    ...mapState(useUserNewsletterStore, ['data', 'hasChanged']),
  },
  methods: {
    ...mapActions(useUserNewsletterStore, [
      'setCustomerNewsletter',
      'setPartnerNewsletter',
      'reset',
      'saveNewsletterData',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
.newsletter {
  margin-bottom: 24px;

  p {
    margin: 12px 0 0 0;
    color: $grey60;
    max-width: 500px;
  }
}

.newsletter-switch {
  display: inline-block;

  strong {
    display: block;
    min-width: 120px;
    margin-right: 16px;
  }
}
</style>
